import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button,
  Input,
  Label,
  Select,
} from '@ipc/ipc-components';
import {
  getData,
  getColumns,
  getIsLoading,
  getCheckedRows,
} from '../redux/selectors/PredesTransactionsSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';
import PredesTransactionsHistoryContainer from '../../transactions-history/predes/containers/PredesTransactionsHistoryContainer';
import { postPredesTransactionsBulkReleaseRequestActionCreator } from '../release/redux/actions/PredesTransactionsReleaseActions';
import { TransactionsStyle } from '../../component/Transactions.styles';
import { getUserRole } from '../../../../../common/user/redux/selectors/UserDataSelectors';
import downloadTypes from '../../../../../common/tables/excel/DownloadTypes';
import { postPredesTransactionsBulkRejectRequestActionCreator } from '../reject/redux/actions/PredesTransactionsRejectActions';

class PredesTransactionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDayCount: 10,
      transactionDirection: 'BOTH',
    };
    this.applyBulkRelease = this.applyBulkRelease.bind(this);
    this.applyBulkReject = this.applyBulkReject.bind(this);
    this.clickApplyButton = this.clickApplyButton.bind(this);
    this.props.tableLoadData(
      {
        tableId: 'PREDES_TRANSACTIONS',
      },
      this.props.appContext.appContext,
      {
        impcCode: this.props.clickedRow.impc,
        selectedDays: this.state.selectedDayCount,
        transactionDirection: this.state.transactionDirection,
      },
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.clickedRow !== prevProps.clickedRow) {
      this.props.tableLoadData(
        {
          tableId: 'PREDES_TRANSACTIONS',
        },
        this.props.appContext.appContext,
        {
          impcCode: this.props.clickedRow.impc,
          selectedDays: this.state.selectedDayCount,
          transactionDirection: this.state.transactionDirection,
        },
      );
    }
  }

  handleDirectionChange = (direction) => {
    this.setState({
      transactionDirection: direction.value,
    });
    this.props.tableLoadData(
      {
        tableId: 'PREDES_TRANSACTIONS',
      },
      this.props.appContext.appContext,
      {
        impcCode: this.props.clickedRow.impc,
        selectedDays: this.state.selectedDayCount,
        transactionDirection: direction.value,
      },
    );
  }

  enterPressed = (e) => {
    const code = e.keyCode || e.which;
    if (code === 13) {
      this.clickApplyButton();
    }
  }

  handleChange(e) {
    this.setState({
      selectedDayCount: e.target.value,
    });
  }

  clickApplyButton() {
    this.props.tableLoadData(
      {
        tableId: 'PREDES_TRANSACTIONS',
      },
      this.props.appContext.appContext,
      {
        impcCode: this.props.clickedRow.impc,
        selectedDays: this.state.selectedDayCount,
        transactionDirection: this.state.transactionDirection,
      },
    );
  }

  async applyBulkRelease() {
    const transactionIds = [];
    this.props.checkedRows.map((index) => ((index.status === 'ON_HOLD' && index.arrivalDateTime !== null) ? transactionIds.push(index.id) : transactionIds));
    await this.props.postPredesTransactionsBulkReleaseRequestActionCreator(
      this.props.appContext,
      transactionIds,
    );

    this.clickApplyButton();
  }

  async applyBulkReject() {
    const transactionIds = [];
    this.props.checkedRows.map((index) => (index.status === 'ON_HOLD' ? transactionIds.push(index.id) : transactionIds));
    await this.props.postPredesTransactionsBulkRejectRequestActionCreator(
      this.props.appContext,
      transactionIds,
    );

    this.clickApplyButton();
  }

  render() {
    const options = [{ label: 'Both', value: 'BOTH' }, { label: 'Inbound', value: 'INBOUND' }, { label: 'Outbound', value: 'OUTBOUND' }];
    return (
      <TransactionsStyle>
        <Label>Direction</Label>
        <Label>
          <Select
            value={options.value}
            placeholder="Both"
            options={options}
            onChange={this.handleDirectionChange}
            className="selected-impc"
          />
        </Label>
        <Label>
          Show transactions for the last
          <Input
            className="last-day-input"
            value={this.state.selectedDayCount}
            onChange={(e) => this.handleChange(e)}
            onKeyPress={this.enterPressed}
          />
          days
        </Label>
        <Button type="button" className="action-buttons" onClick={this.clickApplyButton}>
          Apply
        </Button>
        {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER'))
        && (this.props.checkedRows !== undefined
          && this.props.checkedRows.length !== 0
          && this.props.checkedRows.filter((index) => (index.status === 'ON_HOLD' && index.arrivalDateTime !== null)).length !== 0) && (
          <Button className="action-buttons primary-button-false" onClick={this.applyBulkRelease}>
            RELEASE
          </Button>
        )}
        {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER'))
        && (this.props.checkedRows !== undefined
          && this.props.checkedRows.length !== 0
          && this.props.checkedRows.filter((index) => (index.status === 'ON_HOLD')).length !== 0) && (
          <Button className="action-buttons primary-button-false" onClick={this.applyBulkReject}>
            REJECT
          </Button>
        )}
        <ListTable
          listId={TableDefinitions.PREDES_TRANSACTIONS.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
          getTrProps={this.selectedRow}
          keyField="id"
          selectCheckbox
          downloadType={downloadTypes.EXCEL}
          getSubComponentProps={(row) => (
            <div style={{ padding: '20px' }}>
              <PredesTransactionsHistoryContainer
                row={row}
                refreshTransactions={this.clickApplyButton}
              />
            </div>
          )}
        />
      </TransactionsStyle>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    isLoading: getIsLoading(state),
    checkedRows: getCheckedRows(state),
    userRole: getUserRole(state),
  };
}

PredesTransactionsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
  checkedRows: PropTypes.arrayOf(PropTypes.object),
  postPredesTransactionsBulkReleaseRequestActionCreator: PropTypes.func,
  postPredesTransactionsBulkRejectRequestActionCreator: PropTypes.func,
  userRole: PropTypes.arrayOf(PropTypes.string),
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  postPredesTransactionsBulkReleaseRequestActionCreator,
  postPredesTransactionsBulkRejectRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PredesTransactionsContainer);
